module.exports = __webpack_public_path__ + "img/icon_management01.b50c59a8.svg";